export const ENGLISH_LANGUAGE_CODE = 'en';
export const NORWEGIAN_LANGUAGE_CODE = 'nb';

export const LANGUAGES_CODES = [ENGLISH_LANGUAGE_CODE, NORWEGIAN_LANGUAGE_CODE] as const;
export type LanguageCode = (typeof LANGUAGES_CODES)[number];

export function isLanguageCode(str: unknown): str is LanguageCode {
  return LANGUAGES_CODES.includes(str as LanguageCode);
}

export const DEFAULT_LANGUAGE_CODE: LanguageCode = 'nb';
export const DEFAULT_LANGUAGE_CODE_WEBSITE: LanguageCode = 'en';
